var map = {
	"./apple.png": 84,
	"./apricot.png": 85,
	"./aprium.png": 86,
	"./asian_pear.png": 87,
	"./avocado.png": 88,
	"./blackberry.png": 89,
	"./blueberry.png": 90,
	"./cherry.png": 91,
	"./dates.png": 92,
	"./feijoas.png": 93,
	"./fig.png": 94,
	"./golden_raspberry.png": 95,
	"./grapefruit.png": 96,
	"./grapes.png": 97,
	"./jujube.png": 98,
	"./kiwi.png": 99,
	"./lemon.png": 100,
	"./loquat.png": 101,
	"./melon.png": 102,
	"./mulberry.png": 103,
	"./nectarine.png": 104,
	"./passionfruit.png": 105,
	"./peach.png": 106,
	"./pear.png": 107,
	"./persimmon.png": 108,
	"./plum.png": 109,
	"./pluot.png": 110,
	"./pomegranate.png": 111,
	"./raspberry.png": 112,
	"./strawberry.png": 113,
	"./tayberry.png": 114,
	"./white_pomegranate.png": 115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;